import angular from 'angular'
import uiRouter from 'angular-ui-router'
import bookingsComponent from './bookings.component'
import cacheService from '../../services/cache.service'
import booking from './booking/booking'
import bookingsRun from './bookings.run';
import languageService from '../../services/language.service';

const bookingsModule = angular.module('bookings', [
        uiRouter,
        cacheService,
        booking
    ])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject'
        //Redirect default child state from abstract parent
        $stateProvider
            .state('bookings', {
                resolve: {
                    data: function($q, $stateParams, languageService) {
                        'ngInject';
                       languageService.setLanguage($stateParams.locale);
                        var defer = $q.defer();
                        defer.resolve('Success!');
                        return defer.promise;
                    }
                },        
                url: '/{locale}/bookings',
                redirectTo: 'bookings.booking.view',
                views: {
                    'main@': {
                        template: '<bookings></bookings>'
                    },
                    'navbar@': {
                        template: '<navbar></navbar>'
                    },
                    'footer@': {
                        template: '<footer></footer>'
                    }
                }
            })
    })
    .component('bookings', bookingsComponent)
    .run(bookingsRun)
    .name

export default bookingsModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/bookings.js